/*
 * Modal storage module
 */
export const SHOW_MODAL = 'SHOW_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const SET_CLOSE_CALLBACK = 'SET_CLOSE_CALLBACK';



// WEBPACK FOOTER //
// ./templates/bazis/assets/js/VueApplication/Storage/mutation-types.js